import React, { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Button, { ButtonSize, ButtonTheme } from 'components/Form/Button'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import Card from 'components/Layout/Card'
import InputSearch from 'components/Form/InputSearch'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store'
import './BundleFilters.scss'
import { bundleActions } from '../../store/bundle-slice'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { PickerValue } from '@mui/x-date-pickers/internals'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import { MediaFormat } from 'types/campaign'

const BundleFilters: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { filters, showFilters } = useSelector((state: RootState) => state.bundles)

  const mediaFormatOptions = useMemo(
    () =>
      Object.entries(MediaFormat).map(([key, value]) => ({
        value: key,
        label: t(`mediaType.${value}`),
      })),
    [t]
  )

  const SearchRow = (): ReactElement => (
    <div className='BundleFilters__search-row'>
      <Button
        theme={ButtonTheme.NAVY_BLUE_OUTLINE}
        size={ButtonSize.SMALL}
        icon={showFilters ? faCaretDown : faCaretUp}
        dataCy={'bundle-filters-toggle'}
        onClick={() => void dispatch(bundleActions.toggleFiltersVisibility())}
      >
        {t('common.filters')}
      </Button>

      <InputSearch
        id='text'
        value={filters.text}
        onChange={text => {
          void dispatch(bundleActions.setFilters({ ...filters, text }))
        }}
        onSubmit={text => {
          void dispatch(bundleActions.setFilters({ ...filters, text }))
        }}
        dataCy={'bundle-search-input'}
      />
    </div>
  )

  const Filters = (): ReactElement => (
    <Card className={'BundleFilters'}>
      <div className={'BundleFilters__container'}>
        <DatePicker
          slotProps={{
            field: {
              clearable: true,
            },
          }}
          label={'Miesiąc i rok'}
          views={['month', 'year']}
          value={filters.month ? new Date(filters.month) : null}
          minDate={new Date('2025-04-01')}
          onChange={(pickerValue: PickerValue) => {
            const month = pickerValue ? new Date(pickerValue).toISOString() : null
            void dispatch(bundleActions.setFilters({ ...filters, month }))
          }}
        />

        <TextField
          select
          label={t('bundle.mediaFormat')}
          value={filters.mediaFormat ?? ''}
          onChange={e => {
            const mediaFormat = e.target.value || null
            void dispatch(bundleActions.setFilters({ ...filters, mediaFormat }))
          }}
        >
          <MenuItem value=''>
            <em>{t('form.all')}</em>
          </MenuItem>
          {mediaFormatOptions.map(opt => (
            <MenuItem
              key={opt.value}
              value={opt.value}
            >
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </Card>
  )

  return (
    <div className='CampaignTableFilters'>
      {SearchRow()}
      {showFilters && Filters()}
    </div>
  )
}

export default BundleFilters
